(function(g) {
  var lastTime = 0;
  var vendors = ['webkit', 'moz'];
  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
      window.cancelAnimationFrame =
        window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function(callback, element) {
          var currTime = new Date().getTime();
          var timeToCall = Math.max(0, 16 - (currTime - lastTime));
          var id = window.setTimeout(function() { callback(currTime + timeToCall); },
            timeToCall);
          lastTime = currTime + timeToCall;
          return id;
      };

  if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function(id) {
          clearTimeout(id);
      };

  var stop = false,
      playing = false,
      then = 0,
      interval = 0,
      fps = 30,
      frameRate = '',
      startTime = 0,
      elapsed = 0,
      frameCount = 0,
      callback = '';

  g.animate = {

    start: function (_fps, _callback) {
      fps = _fps;
      fpsInterval = 1000 / fps;
      callback = _callback;
      then = Date.now();
      startTime = then;
      stop = false;
      playing = true;
      this.tick();
    },

    stop: function () {
      stop = true;
    },

    tick: function () {

      if(stop) {
        playing = false;
        return;
      }

      window.requestAnimationFrame(animate.tick);

      var now = Date.now();
      elapsed = now - then;

      if (elapsed > fpsInterval) {

        then = now - (elapsed % fpsInterval);
        callback();
        
        var sinceStart = now - startTime;
        frameRate = Math.round(1000 / (sinceStart / ++frameCount) * 100) / 100;
      }
    },

    get_isStop: function () {
      return stop;
    },

    set_fps: function ( _fps ) {
      fpsInterval = 1000 / _fps;
    },

    get_fps: function () {
      return frameRate;
    }
  };

}(window));